import { fg } from '@confluence/feature-gating';

import type { GraphQLContentStatus } from '../__types__/ActiveCommentsQuery';
import { CommentType as CommentsType } from '../__types__/ActiveCommentsQuery';

export const buildConsistentActiveCommentsQueryPreloadVariables = (
	contentId: string,
	isArchived?: boolean,
) => {
	return {
		pageId: contentId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		type: [CommentsType.FOOTER],
		first: 1, // Update this with a larger number once we start SSRing footer comments
	};
};

export const buildConsistentActiveCommentsQueryVariables = ({
	pageId,
	type,
	isArchived = false,
}: {
	pageId: string;
	type?: CommentsType | null;
	isArchived?: boolean;
}) => {
	return {
		pageId,
		contentStatus: [isArchived ? 'ARCHIVED' : 'CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		first: fg('confluence_frontend_comments_1k_batch_size') ? 1000 : 250, // This is a temporary fix to get 1000 comments at a time (default 250) for select tenants. It does not enable batching
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		...(fg('confluence-frontend-redesigned-footer-comment') && type && { type: [type] }),
	};
};
